<template>    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">                
                <div class="card mb-5">
                    <div class="card-header p-3 pt-2">
                        <div class="icon icon-lg icon-shape shadow text-center border-radius-xl mt-n4 position-absolute bg-gradient-success shadow-dark">
                            <i class="material-symbols-rounded opacity-10 text-white" aria-hidden="true">add_circle</i>
                        </div>
                        <h6 class="mb-2" style="margin-left: 4.5rem !important;">{{ $t('lifecycle.Birth') }}</h6>
                        <div class="row" style="margin-top: -30px;">
                            <div class="col-lg-6">
                            </div>                            
                        </div>                        
                    </div>
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3 mt-5 text-danger">
                        {{ $t('common.Coming_soon') }}...
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>        
</template>

<script>
//import axios from 'axios'

export default {
    name: 'Lifecycle_birth_page',
    components: {
    },
    data() {
        return {
            gets: [],            
            dataTableInstance: null,
        }
    },
    async mounted() {        
    },
    methods: {        
    }
}
</script>